import { render } from "./Otp.vue?vue&type=template&id=3d01b866&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=3d01b866&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d01b866"]])

export default __exports__